var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Log_Out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Log_Out",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 19.25H6.25C6.91406 19.25 7.5 18.7031 7.5 18C7.5 17.3359 6.91406 16.75 6.25 16.75H3.75C3.04688 16.75 2.5 16.2031 2.5 15.5V5.5C2.5 4.83594 3.04688 4.25 3.75 4.25H6.25C6.91406 4.25 7.5 3.70312 7.5 3C7.5 2.33594 6.91406 1.75 6.25 1.75H3.75C1.64062 1.75 0 3.42969 0 5.5V15.5C0 17.5703 1.64062 19.25 3.75 19.25ZM19.6875 9.83594L14.0625 4.52344C13.7891 4.25 13.3984 4.21094 13.0469 4.32812C12.6953 4.48438 12.5 4.83594 12.5 5.1875V8H7.5C6.79688 8 6.25 8.58594 6.25 9.25V11.75C6.25 12.4531 6.79688 13 7.5 13H12.5V15.8125C12.5 16.1641 12.6953 16.5156 13.0469 16.6719C13.3984 16.7891 13.7891 16.75 14.0625 16.4766L19.6875 11.1641C20.0781 10.8516 20.0781 10.1875 19.6875 9.83594Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default ForwardRef;